

import { Instagram } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Tab, Tabs } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../App.css';
import AddPlanDrawer from './Addplandrawer';
import BrandHeader from './BrandHeader';
import Navbar from './Navbar';

const ViewPlan = () => {
  const location = useLocation();
  const { planName, brandName } = location.state || {};

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('');
  const [recentInfluencers, setRecentInfluencers] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [visibleCount, setVisibleCount] = useState(10); // Load 10 rows initially
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    const storedInfluencers = JSON.parse(localStorage.getItem('recentInfluencers')) || [];
    setRecentInfluencers(storedInfluencers.slice(0, 5));
  }, []);

  useEffect(() => {
    if (!planName) return;

    setLoading(true);
    axios
      .post('https://server-side-influencer.onrender.com/brand/plansnames', { planName })
      .then((response) => {
        setData(response.data.data);
        if (response.data.data.length > 0) {
          const firstListName = response.data.data[0].brandPlans[0].listName;
          setActiveTab(firstListName);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, [planName]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 780);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchUpdatedData = () => {
    setLoading(true);
    axios
      .post('https://server-side-influencer.onrender.com/brand/plansnames', { planName })
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching updated data:", error);
        setLoading(false);
      });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setVisibleCount(10); // Reset count on tab changessss
    fetchUpdatedData();
  };

  const handleDelete = (id) => {
    axios
      .delete(`https://server-side-influencer.onrender.com/brand/deleteInfluencer/${id}`)
      .then(() => {
        fetchUpdatedData();
      })
      .catch((error) => {
        console.error("Error deleting influencer:", error);
      });
  };

  const listNames = Array.from(new Set(data.flatMap(item =>
    item.brandPlans.map(plan => plan.listName)
  )));

  const filteredData = data.flatMap(item =>
    item.brandPlans.filter(plan => plan.listName === activeTab)
  );

  const loadMoreData = () => {
    setLoadingMore(true);
    setTimeout(() => {
      setVisibleCount(prev => prev + 10);
      setLoadingMore(false);
    }, 500);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'flex-start', width: '100%' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 50, color: 'white' }}>
        <Navbar />
      </div>

      <div style={{ height: '100vh', width: '100%', marginLeft: '0px',  }}>
        <BrandHeader page="Veiw plan" />

        <div style={{ padding: '2rem' }}>
          <h1 className="text-center text-2xl font-bold py-4 mb-10">View Plan and List</h1>

          <div className="flex justify-end mb-4 ml-10">
            <AddPlanDrawer planName={planName} brandName={brandName} fetchUpdatedData={fetchUpdatedData} />
          </div>

          <Box sx={{ width: '100%' }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="Tabs for each influencer list"
              variant="scrollable"
              scrollButtons="auto"
              sx={{ marginBottom: 2, marginLeft: isMobile ? 0 : 10 }}
            >
              {listNames.map((listName, index) => (
                <Tab key={index} label={listName} value={listName} />
              ))}
            </Tabs>

            <TabContent
              data={filteredData}
              visibleCount={visibleCount}
              onDelete={handleDelete}
              loading={loading}
              loadMoreData={loadMoreData}
              loadingMore={loadingMore}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

const TabContent = ({ data, visibleCount, onDelete, loading, loadMoreData, loadingMore, isMobile}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);

  const formatNumber = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1) + "K";
    return num;
  };

  return (
    <div className="overflow-x-auto shadow-md sm:rounded-lg" style={{

   marginLeft: isMobile ? '110px' : '0px',
     marginRight: isMobile ? '40px' : '0px'
}}>
      <table className="w-full text-sm text-left text-gray-500 bg-white   "style={{

  marginRight: isMobile ? '30px' : '0px',
  marginLeft: isMobile ? '0px' : '50px',
}}
 >
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th className="px-6 py-3 whitespace-nowrap">Profile Pic</th>
            <th className="px-6 py-3 whitespace-nowrap">User Name</th>
            <th className="px-6 py-3 whitespace-nowrap">Name</th>
            <th className="px-6 py-3 whitespace-nowrap">Followers</th>
            <th className="px-6 py-3 whitespace-nowrap">Avg ER</th>
            <th className="px-6 py-3 whitespace-nowrap">Avg Likes</th>
            <th className="px-6 py-3 whitespace-nowrap">Avg Comments</th>
            <th className="px-6 py-3 whitespace-nowrap">Avg Interactions</th>
            <th className="px-6 py-3 whitespace-nowrap">EngagementRate</th>
            <th className="px-6 py-3 whitespace-nowrap">Platform</th>
            <th className="px-6 py-3 whitespace-nowrap">URL</th>
          </tr>
        </thead>
        <tbody>
          {loading
            ? Array(5).fill().map((_, index) => (
              <tr key={index} className="border-b">
                <td colSpan={11} className="px-6 py-4">
                  <Skeleton height={50} width="100%" />
                </td>
              </tr>
            ))
            : data.slice(0, visibleCount).map((plan, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <td className="px-6 py-4">
                  <img
                    src={plan.image || 'https://res.cloudinary.com/dwy9jfjpq/image/upload/v1739715011/manager_profile_pics/xru8bht53ml5f5rvui9y.jpg'}
                    alt={plan.screenName}
                    style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                  />
                </td>
                <td className="px-6 py-4 relative">
                  {plan.screenName || 'NA'}
                  {hoveredIndex === index && (
                    <IconButton
                      style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: 'red' }}
                      onClick={() => onDelete(plan.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">{plan.name || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{formatNumber(plan.usersCount) || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{plan.avgER || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{formatNumber(plan.avgLikes) || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{formatNumber(plan.avgComments) || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{formatNumber(plan.avgInteractions) || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{plan.avgER || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">{plan.platform || 'NA'}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <a href={plan.url} target="_blank" rel="noopener noreferrer">
                    <Instagram style={{ color: '#E1306C', fontSize: 24 }} />
                  </a>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {data.length > visibleCount && (
        <div className="text-center mt-4 mb-4 ml-12">
          {!loadingMore ? (
            <button
              onClick={loadMoreData}
              className=" ml-12 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-white"
            >
              Load More
            </button>
          ) : (
            <div className="text-gray-600 text-sm mt-2">Loading...</div>
          )}
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default ViewPlan;
